module.exports = __webpack_public_path__ + "static/media/landing-banner-d.bba2c117.jpg";